import { UserPersonal } from '@owc/connection-wko-manager';

export interface Image {
  src: string;
  sizes?: string;
  srcset?: string;
  alt?: string;
  ratio?: string;
  width?: number;
  height?: number;
}

export enum ModalTheme {
  Default = 1,
  Highlight = 2,
  Dark = 3,
}

export interface Modal {
  headline: string;
  text: string;
  image?: Image;
  closeLabel?: string;
  theme?: ModalTheme;
}

export interface Dealer {
  address: {
    city: string;
    country: string;
    district: string;
    latitude: number;
    longitude: number;
    line1: string;
    line2: string;
    line3: string;
    zipcode: string;
  };
  baseInfo: {
    companyId: string;
    name1: string;
    name2: string;
    name3: string;
    name4: string;
    name5: string;
    outletId: string;
  };
}

export interface Feedback {
  headline: string;
  copy: string;
  subheadline?: string;
  subcopy?: string;
  icon?: string;
}

export enum NextBestActionType {
  Default = 1,
  DealerSelection = 2,
  LeadoutLink = 3,
  MercedesMe = 4,
}

export interface UserProfile {
  firstName?: string;
  middleInitial?: string;
  lastName1?: string;
  lastName2?: string;
  namePrefix?: string;
  accountCountryCode?: string;
  mobilePhoneNumber?: string;
  landlinePhone?: string;
  salutationCode?: string;
  preferredLanguageCode?: string;
  birthday?: string;
  title?: string;
  email?: string;
  address?: Address;
  companies?: Array<Company>;
}

interface Address {
  floorNo?: string;
  street?: string;
  houseNo?: string;
  streetType?: string;
  houseName?: string;
  doorNo?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  postOfficeBox?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  state?: string;
  countryCode?: string;
}

interface Company {
  companyId?: string;
  companyName?: string;
  roles?: CompanyRoles;
}

interface CompanyRoles {
  companyRoles?: Array<string>;
  fleetRoles?: {
    [key: string]: Array<string>;
  };
}
